import { environment } from 'src/environments/environment';
import { LoginResponse } from '../interfaces/auth.interface';
import { saveSession } from './auth.storage';

const SSO_HASH = '#sso=';
const SSO_TIMEOUT_MS = 10_000;

/**
 * login ต่อจาก Module-Pos-Admin (SSO): Pos-Admin เปิดหน้า BO พร้อม #sso=<ticket>
 * แลก ticket เป็น token ของ BO ก่อน Angular เริ่ม — AuthGuard จึงเห็นว่า login แล้วตั้งแต่ navigation แรก
 * ไม่สำเร็จ (ticket หมดอายุ/ใช้ซ้ำ/API ล่ม) → เปิดหน้าตามปกติ ถ้ายังไม่ login AuthGuard พาไปหน้า login แล้วกลับมาหน้าเดิม
 */
export async function consumeSsoTicket(): Promise<void> {
    if (!location.hash.startsWith(SSO_HASH)) return;
    const ticket = location.hash.slice(SSO_HASH.length);

    // ลบ ticket ออกจาก URL ก่อน router อ่าน — ไม่ค้างใน history และไม่ติดไปตอน copy ลิงก์
    history.replaceState(history.state, '', location.pathname + location.search);

    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), SSO_TIMEOUT_MS);
    try {
        const res = await fetch(`${environment.apiUrl}auth/sso`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ ticket }),
            signal: ctrl.signal,
        });
        const body = await res.json().catch(() => null);
        if (!res.ok) throw new Error(body?.message || `HTTP ${res.status}`);
        saveSession((body as LoginResponse).data);
    } catch (err) {
        console.warn('SSO login ไม่สำเร็จ — ใช้ session เดิมหรือ login ด้วยรหัสผ่าน:', err);
    } finally {
        clearTimeout(timer);
    }
}
